import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  id: 1,
  name: 'Dr. Alejandro Voss',
  role: 'Director Clínico & Implantología',
  img: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=80'
}, {
  id: 2,
  name: 'Dra. Elena Rostova',
  role: 'Especialista en Estética Dental',
  img: 'https://images.unsplash.com/photo-1594824436998-058a231d6114?w=800&q=80'
}, {
  id: 3,
  name: 'Dr. Marcus Chen',
  role: 'Ortodoncia Digital Avanzada',
  img: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80'
}];
export function Team() {
  return <section id="equipo" className="py-24 bg-night-900 relative z-20" data-id="element-108">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-110">
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-4" data-id="element-111">
            Nuestro <span className="text-gold" data-id="element-112">Equipo</span>
          </h2>
          <p className="font-sans text-pearl/70 max-w-2xl mx-auto" data-id="element-113">
            Profesionales de renombre internacional dedicados a la excelencia y
            el arte de la odontología moderna.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-114">
          {team.map((member, index) => <motion.div key={member.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group cursor-pointer" data-id="element-115">
              <div className="relative overflow-hidden rounded-sm aspect-[3/4] mb-6" data-id="element-116">
                <div className="absolute inset-0 bg-night-900/40 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-117" />
                <img src={member.img} alt={member.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transform group-hover:scale-105 transition-all duration-700" data-id="element-118" />
                {/* Subtle gold border on hover */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-gold/30 transition-colors duration-500 z-20" data-id="element-119" />
              </div>
              <div className="text-center" data-id="element-120">
                <h3 className="font-serif text-2xl text-white mb-1" data-id="element-121">
                  {member.name}
                </h3>
                <p className="font-sans text-gold text-sm uppercase tracking-widest" data-id="element-122">
                  {member.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}